/**
 * CA-211: always-on build-version stamp — the same contract every
 * Black Ram Labs web app carries (lift-assisted VersionStamp/LA-223,
 * app-web_race-results VersionOverlay/RR-67, BRDEV-918). Small
 * vertical text along the bottom-left edge, faint enough to ignore
 * but legible in screenshots so a report always carries the build.
 *
 * The string is computed at build time by vite.config.ts
 * (computeBuildVersion — git tag/sha/branch over the package.json
 * version; "-dirty" only on `vite dev`) and injected via `define` as
 * `import.meta.env.VITE_BUILD_VERSION`. An empty value renders
 * nothing — a version that's never wrong beats one that's often
 * stale.
 */
export default function VersionStamp() {
  const version = import.meta.env.VITE_BUILD_VERSION ?? '';
  if (version === '') return null;
  return (
    <div className="version-stamp" aria-hidden="true">
      {version}
    </div>
  );
}
